import { inject, Injectable } from '@angular/core';
import { SnackbarService } from '../components/snackbar/snackbar.service';
import { GraphQLError } from '../interfaces/common.interface';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private _snackBarService = inject(SnackbarService);

  public handleGraphQLErrors(apolloErrors: GraphQLError[]) {
    if (apolloErrors.length > 1) {
      const errorList = [];
      apolloErrors.forEach((error) => {
        errorList.push(this._getErrorMessage(error));
      });
      this._snackBarService.showSystemErrorNotification(
        errorList.join('<br/>')
      );
    } else {
      this._snackBarService.showSystemErrorNotification(
        this._getErrorMessage(apolloErrors[0])
      );
    }
  }

  private _getErrorMessage(error: GraphQLError): string {
    if (
      error?.extensions?.validation &&
      Object.keys(error?.extensions?.validation)?.length
    ) {
      return Object.values(error?.extensions?.validation)
        .map(
          (errors) =>
            `<ul>${errors.map((err) => `<li>${err}</li>`).join('')}</ul>`
        )
        .join('');
    }
    return error.message || `unknown error occurred`;
  }
}
